import classNames from 'classnames';

import { Arrow, BrandArrow } from '@/icons/index';

import styles from './Arrows.module.scss';

const PrevArrow = ({ onClick, className, brand }) => {
  return (
    <span
      className={classNames(['slick-arrow', styles.arrow, className])}
      onClick={onClick}
      itemScope
      itemType='https://schema.org/Property'
    >
      <span className={styles.arrowBlock}>
        {brand ? <BrandArrow width={26} /> : <Arrow width={26} />}
      </span>
    </span>
  );
};

export default PrevArrow;
